import React from 'react'
import Navbar from '../components/navbar'
import Container from '../components/container'

const Home = () => {
  return (
    <>
      <Navbar/>
      <Container/>
    </>
      
    
  )
}

export default Home
